<template>
    <div class="adv-input">
        <input
            :ref="onRef"
            type="text"
            :maxLength="maxLength"
            :value="val"
            @input="handleInput"
            @focus="shouldGetSuggestion"
            :placeholder="placeholder"
            :class="[
                'input',
                error ? 'error' : '',
                clearable ? 'clearable' : ''
            ]"
            v-outsideclick="outSideClick"
        />
        <i
            v-if="clearable && val"
            @click="handleClear"
            class="iconfont icon-Empty"
            :class="{ focus }"
        />
        <div
            class="email-suggestion"
            v-if="showSuggestion && suggestionList.length"
            @click.stop=""
        >
            <p
                v-for="email in suggestionList"
                :key="email"
                @click="selectEmail(email)"
            >
                {{ email }}
            </p>
        </div>
        <p class="adv-input__error" v-if="error">{{ error }}</p>
    </div>
</template>

<script>

const emailSuggestion = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'aol.com',
    'icloud.com'
];

export default {
    emits: ['changeValue'],
    name: 'AdvInput',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        validator: {
            type: Function,
            default: null
        },
        formatter: {
            type: Function,
            default: null
        },
        maxLength: {
            type: Number,
            default: 100
        },
        value: {
            //  uncontrolled
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: true
        },
        errorMsg: {
            type: String,
            default: 'Please check your input value.'
        }
    },
    // model: {
    //     prop: 'value',
    //     event: 'changeValue'
    // },
    data: function() {
        return {
            error: '',
            showSuggestion: false,
            suggestionList: [],
            focus: false,
            val: this.value,
            inputRef: null,
        };
    },
    methods: {
        onRef(e) {
            this.inputRef = e;
        },
        handleClear() {
            this.val = this.inputRef.value = '';
            this.$emit('changeValue', '');
        },
        selectEmail(email) {
            this.showSuggestion = false;
            this.val = email;
            this.$emit('changeValue', email);
        },
        async _validate() {
            const val = this.inputRef.value;
            let res = await this.validate(val);
            return res;
        },
        handleInput($event) {
            this.resetError();
            let val = $event.target.value;
            typeof this.formatter === 'function' &&
                (val = this.formatter(val)) &&
                (this.inputRef.value = val);
            this.shouldGetSuggestion();
            this.val = val;
            this.$emit('changeValue', val);
        },
        async outSideClick() {
            this.focus = false;
            this.showSuggestion = false;
            let val = (this.inputRef.value || '').trim();
            this.inputRef.value = val;
            await this.validate(val);
        },
        shouldGetSuggestion() {
            this.focus = true;
            this.type === 'email' &&
                (this.showSuggestion = true) &&
                this.getSuggestion();
        },
        getSuggestion() {
            if (!this.showSuggestion) {
                return []; 
            }
            const value = this.inputRef.value || '';
            const reg = /([^@]*)@?(.*)/;
            const matches = value.match(reg);
            const suffix = (matches && matches[2]) || '';
            let prefix = (matches && matches[1]) || '';
            const list = emailSuggestion
                .filter(email => {
                    if (suffix) {
                        return email.startsWith(suffix);
                    } else {
                        return !!value;
                    }
                })
                .map(e => prefix + '@' + e);
            this.suggestionList = list;
        },
        //  Verify and set error prompts
        async validate(val) {
            if (this.validator) {
                const pass = await this.validator(val).catch(e => {
                    let errMsg =
                        typeof e?.errorInfo === 'string'
                            ? e.errorInfo
                            : 'Invalid Input';
                    this.setError(errMsg);
                });
                if (pass) {
                    this.resetError(); 
                }
                return !!pass;
            } else {
                this.resetError();
                return true;
            }
        },
        resetError() {
            this.error = '';
        },
        setError(msg) {
            this.error = msg || this.errorMsg || '';
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
    },
    mounted() {
        if (!this.isMobileSize) {
            this.inputRef?.focus();
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.adv-input {
    position: relative;
    .icon-Empty {
        position: absolute;
        right: 20px;
        width: 16px;
        height: 16px;
        top: 20px;
        transform: translateY(-50%);
        color: #d5d7de;
        cursor: pointer;
        &.focus {
            color: #4c84ff;
        }
    }
    input {
        width: 400px;
        height: 40px;
        padding: 0 15px;
        box-shadow: 30px 0 40px 0 rgba(79, 134, 255, 0.04);
        font-size: 14px;
        border-radius: 20px;
        border: solid 1px #c6c8d1;
        background-color: #fff;
        &.clearable {
            padding-right: 31px;
        }
        &:focus {
            border-color: #4c84ff;
        }
        @include media-600 {
            width: 100%;
        }
        ::-webkit-input-placeholder {
            color: #c6c8d1;
        }
        &.error {
            border-color: #f0454c;
        }
    }
    .email-suggestion {
        position: absolute;
        left: 6px;
        top: 44px;
        width: 360px;
        max-height: 190px;
        overflow: auto;
        border-radius: 4px;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        background-color: #fff;
        padding: 7px 0;
        z-index: 10;
        box-sizing: border-box;
        @include media-600 {
            width: 100%;
            left: 0;
        }
        ::-webkit-scrollbar {
            width: 4px;
            background-color: #d2d3d7;
        }
        p {
            font-size: 14px;
            color: #191919;
            height: 40px;
            line-height: 40px;
            padding: 0 40px 0 10px;
            overflow: hidden;
            white-space: nowrap;
            cursor: pointer;
            text-align: left;
            padding: 0 20px;
            &:hover {
                background-color: #f6f7fb;
            }
        }
    }
    .adv-input__error {
        font-size: 12px;
        color: #f0454c;
        text-align: left;
        transform: translate(6px, 5px);
    }
}
</style>
